import React from 'react'
import { FormProvider } from 'react-hook-form'

// formRef lets a caller submit the form itself, so validation can run before a
// DOM submit event is ever fired. See the submit handler in components/inquire.
const Form = ({ children, onSubmit, formProps, className = '', formRef = null, id }) => {
  return (
    <FormProvider {...formProps}>
      <form
        ref={formRef}
        id={id}
        noValidate
        onSubmit={formProps.handleSubmit(onSubmit)}
        className={className}
      >
        {children}
      </form>
    </FormProvider>
  )
}
export default Form
